import React from 'react'
import { Link } from 'gatsby'
import { LocaleContext } from 'styles/locale-provider'

import { Links } from './index.styled'

const Terms = ({ className, onClick = () => {} }) => {
  const { localeText, getI18Url } = React.useContext(LocaleContext)

  return (
    <Links className={className} onClick={onClick}>
      <li>
        <Link to={getI18Url('/legal/')}>{localeText['terms']}</Link>
      </li>
      <li>
        <Link to={getI18Url('/legal#policy')}>
          {localeText['privacy.notice']}
        </Link>
      </li>
    </Links>
  )
}

export default Terms
